[
  {
    "family": "Data Channels",
    "source": null,
    "evidence": null,
    "expectedOperations": 3,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 3,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/channels/v2/branches",
        "summary": "List physical branches",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/channels/v2/electronic-channels",
        "summary": "List electronic channels",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/channels/v2/phone-channels",
        "summary": "List phone channels",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Consents",
    "source": "repo-code",
    "evidence": "packages/insurance/receiver-data/src/opin/external-consent/service.ts",
    "expectedOperations": 3,
    "supportedOperations": 0,
    "variantOperations": 2,
    "missingOperations": 1,
    "coveragePercent": 67,
    "status": "partial",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/consents/v3/consents",
        "summary": "Create consent",
        "requiredScopes": ["consents"],
        "mockOpinStatus": "version-variant",
        "mockOpinPath": "/open-insurance/consents/v2/consents",
        "mockOpinSummary": "Create MockOPIN-readable consent during local receiver flow"
      },
      {
        "method": "get",
        "path": "/open-insurance/consents/v3/consents/{consentId}",
        "summary": "Read consent",
        "requiredScopes": ["consents"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "delete",
        "path": "/open-insurance/consents/v3/consents/{consentId}",
        "summary": "Revoke consent",
        "requiredScopes": ["consents"],
        "mockOpinStatus": "version-variant",
        "mockOpinPath": "/open-insurance/consents/v2/consents/{consentId}",
        "mockOpinSummary": "Revoke MockOPIN-readable consent during local receiver flow"
      }
    ]
  },
  {
    "family": "Resources",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/resources/v3/resources",
        "summary": "List consented resources",
        "requiredScopes": ["resources"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Customers",
    "source": null,
    "evidence": null,
    "expectedOperations": 6,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 6,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/customers/v2/personal/identifications",
        "summary": "List personal IDs",
        "requiredScopes": ["customers"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/customers/v2/personal/qualifications",
        "summary": "List personal profiles",
        "requiredScopes": ["customers"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/customers/v2/personal/complimentary-information",
        "summary": "List personal complimentary information",
        "requiredScopes": ["customers"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/customers/v2/business/identifications",
        "summary": "List business IDs",
        "requiredScopes": ["customers"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/customers/v2/business/qualifications",
        "summary": "List business profiles",
        "requiredScopes": ["customers"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/customers/v2/business/complimentary-information",
        "summary": "List business complimentary information",
        "requiredScopes": ["customers"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Auto",
    "source": null,
    "evidence": null,
    "expectedOperations": 4,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 4,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/insurance-auto/v2/insurance-auto",
        "summary": "List insurance-auto",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_AUTO_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-auto/v2/insurance-auto/{policyId}/policy-info",
        "summary": "Read policy info",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_AUTO_POLICYINFO_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-auto/v2/insurance-auto/{policyId}/premium",
        "summary": "Read premium data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_AUTO_PREMIUM_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-auto/v2/insurance-auto/{policyId}/claim",
        "summary": "Read claim data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_AUTO_CLAIM_READ"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Patrimonial",
    "source": null,
    "evidence": null,
    "expectedOperations": 4,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 4,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/insurance-patrimonial/v2/insurance-patrimonial",
        "summary": "List insurance-patrimonial",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_PATRIMONIAL_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-patrimonial/v2/insurance-patrimonial/{policyId}/policy-info",
        "summary": "Read policy info",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_PATRIMONIAL_POLICYINFO_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-patrimonial/v2/insurance-patrimonial/{policyId}/premium",
        "summary": "Read premium data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_PATRIMONIAL_PREMIUM_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-patrimonial/v2/insurance-patrimonial/{policyId}/claim",
        "summary": "Read claim data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_PATRIMONIAL_CLAIM_READ"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Person",
    "source": null,
    "evidence": null,
    "expectedOperations": 4,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 4,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/insurance-person/v2/insurance-person",
        "summary": "List insurance-person",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_PERSON_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-person/v2/insurance-person/{policyId}/policy-info",
        "summary": "Read policy info",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_PERSON_POLICYINFO_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-person/v2/insurance-person/{policyId}/premium",
        "summary": "Read premium data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_PERSON_PREMIUM_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-person/v2/insurance-person/{policyId}/claim",
        "summary": "Read claim data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_PERSON_CLAIM_READ"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Housing",
    "source": null,
    "evidence": null,
    "expectedOperations": 4,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 4,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/insurance-housing/v2/insurance-housing",
        "summary": "List insurance-housing",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_HOUSING_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-housing/v2/insurance-housing/{policyId}/policy-info",
        "summary": "Read policy info",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_HOUSING_POLICYINFO_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-housing/v2/insurance-housing/{policyId}/premium",
        "summary": "Read premium data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_HOUSING_PREMIUM_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-housing/v2/insurance-housing/{policyId}/claim",
        "summary": "Read claim data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_HOUSING_CLAIM_READ"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Financial Risk",
    "source": null,
    "evidence": null,
    "expectedOperations": 4,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 4,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/insurance-financial-risk/v2/insurance-financial-risk",
        "summary": "List insurance-financial-risk",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_FINANCIAL_RISKS_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-financial-risk/v2/insurance-financial-risk/{policyId}/policy-info",
        "summary": "Read policy info",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_FINANCIAL_RISKS_POLICYINFO_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-financial-risk/v2/insurance-financial-risk/{policyId}/premium",
        "summary": "Read premium data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_FINANCIAL_RISKS_PREMIUM_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-financial-risk/v2/insurance-financial-risk/{policyId}/claim",
        "summary": "Read claim data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_FINANCIAL_RISKS_CLAIM_READ"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Responsibility",
    "source": null,
    "evidence": null,
    "expectedOperations": 4,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 4,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/insurance-responsibility/v2/insurance-responsibility",
        "summary": "List insurance-responsibility",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_RESPONSIBILITY_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-responsibility/v2/insurance-responsibility/{policyId}/policy-info",
        "summary": "Read policy info",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_RESPONSIBILITY_POLICYINFO_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-responsibility/v2/insurance-responsibility/{policyId}/premium",
        "summary": "Read premium data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_RESPONSIBILITY_PREMIUM_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-responsibility/v2/insurance-responsibility/{policyId}/claim",
        "summary": "Read claim data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_RESPONSIBILITY_CLAIM_READ"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Rural",
    "source": null,
    "evidence": null,
    "expectedOperations": 4,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 4,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/insurance-rural/v2/insurance-rural",
        "summary": "List insurance-rural",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_RURAL_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-rural/v2/insurance-rural/{policyId}/policy-info",
        "summary": "Read policy info",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_RURAL_POLICYINFO_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-rural/v2/insurance-rural/{policyId}/premium",
        "summary": "Read premium data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_RURAL_PREMIUM_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-rural/v2/insurance-rural/{policyId}/claim",
        "summary": "Read claim data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_RURAL_CLAIM_READ"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Transport",
    "source": null,
    "evidence": null,
    "expectedOperations": 4,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 4,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/insurance-transport/v2/insurance-transport",
        "summary": "List insurance-transport",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_TRANSPORT_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-transport/v2/insurance-transport/{policyId}/policy-info",
        "summary": "Read policy info",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_TRANSPORT_POLICYINFO_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-transport/v2/insurance-transport/{policyId}/premium",
        "summary": "Read premium data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_TRANSPORT_PREMIUM_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-transport/v2/insurance-transport/{policyId}/claim",
        "summary": "Read claim data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_TRANSPORT_CLAIM_READ"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Acceptance And Branches Abroad",
    "source": null,
    "evidence": null,
    "expectedOperations": 4,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 4,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/insurance-acceptance-and-branches-abroad/v2/insurance-acceptance-and-branches-abroad",
        "summary": "List insurance-acceptance-and-branches-abroad",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_ACCEPTANCE_AND_BRANCHES_ABROAD_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-acceptance-and-branches-abroad/v2/insurance-acceptance-and-branches-abroad/{policyId}/policy-info",
        "summary": "Read policy info",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_ACCEPTANCE_AND_BRANCHES_ABROAD_POLICYINFO_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-acceptance-and-branches-abroad/v2/insurance-acceptance-and-branches-abroad/{policyId}/premium",
        "summary": "Read premium data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_ACCEPTANCE_AND_BRANCHES_ABROAD_PREMIUM_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-acceptance-and-branches-abroad/v2/insurance-acceptance-and-branches-abroad/{policyId}/claim",
        "summary": "Read claim data",
        "requiredScopes": ["DAMAGES_AND_PEOPLE_ACCEPTANCE_AND_BRANCHES_ABROAD_CLAIM_READ"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Financial Assistance",
    "source": null,
    "evidence": null,
    "expectedOperations": 3,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 3,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/insurance-financial-assistance/v2/insurance-financial-assistance/contracts",
        "summary": "List contracts",
        "requiredScopes": ["FINANCIAL_ASSISTANCE_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-financial-assistance/v2/insurance-financial-assistance/{contractId}/contract-info",
        "summary": "Read contract info",
        "requiredScopes": ["FINANCIAL_ASSISTANCE_CONTRACTINFO_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-financial-assistance/v2/insurance-financial-assistance/{contractId}/movements",
        "summary": "Read movements",
        "requiredScopes": ["FINANCIAL_ASSISTANCE_MOVEMENTS_READ"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Capitalization Title",
    "source": null,
    "evidence": null,
    "expectedOperations": 4,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 4,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/insurance-capitalization-title/v2/insurance-capitalization-title/plans",
        "summary": "List plans",
        "requiredScopes": ["CAPITALIZATION_TITLE_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-capitalization-title/v2/insurance-capitalization-title/{planId}/plan-info",
        "summary": "Read plan info",
        "requiredScopes": ["CAPITALIZATION_TITLE_PLANINFO_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-capitalization-title/v2/insurance-capitalization-title/{planId}/events",
        "summary": "Read events",
        "requiredScopes": ["CAPITALIZATION_TITLE_EVENTS_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-capitalization-title/v2/insurance-capitalization-title/{planId}/settlements",
        "summary": "Read settlements",
        "requiredScopes": ["CAPITALIZATION_TITLE_SETTLEMENTS_READ"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Pension Plan",
    "source": null,
    "evidence": null,
    "expectedOperations": 6,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 6,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/insurance-pension-plan/v2/insurance-pension-plan/contracts",
        "summary": "List contracts",
        "requiredScopes": ["PENSION_PLAN_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-pension-plan/v2/insurance-pension-plan/{pensionIdentification}/contract-info",
        "summary": "Read contract info",
        "requiredScopes": ["PENSION_PLAN_CONTRACTINFO_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-pension-plan/v2/insurance-pension-plan/{pensionIdentification}/movements",
        "summary": "Read movements",
        "requiredScopes": ["PENSION_PLAN_MOVEMENTS_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-pension-plan/v2/insurance-pension-plan/{pensionIdentification}/portabilities",
        "summary": "Read portabilities",
        "requiredScopes": ["PENSION_PLAN_PORTABILITIES_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-pension-plan/v2/insurance-pension-plan/{pensionIdentification}/withdrawals",
        "summary": "Read withdrawals",
        "requiredScopes": ["PENSION_PLAN_WITHDRAWALS_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-pension-plan/v2/insurance-pension-plan/{pensionIdentification}/claim",
        "summary": "Read claims",
        "requiredScopes": ["PENSION_PLAN_CLAIM_READ"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Life Pension",
    "source": null,
    "evidence": null,
    "expectedOperations": 6,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 6,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/insurance-life-pension/v2/insurance-life-pension/contracts",
        "summary": "List insurance-life-pension",
        "requiredScopes": ["LIFE_PENSION_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-life-pension/v2/insurance-life-pension/{certificateId}/contract-info",
        "summary": "Read contract info",
        "requiredScopes": ["LIFE_PENSION_CONTRACTINFO_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-life-pension/v2/insurance-life-pension/{certificateId}/movements",
        "summary": "Read movements",
        "requiredScopes": ["LIFE_PENSION_MOVEMENTS_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-life-pension/v2/insurance-life-pension/{certificateId}/portabilities",
        "summary": "Read portabilities",
        "requiredScopes": ["LIFE_PENSION_PORTABILITIES_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-life-pension/v2/insurance-life-pension/{certificateId}/withdrawals",
        "summary": "Read withdrawals",
        "requiredScopes": ["LIFE_PENSION_WITHDRAWALS_READ"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/insurance-life-pension/v2/insurance-life-pension/{certificateId}/claim",
        "summary": "Read claims",
        "requiredScopes": ["LIFE_PENSION_CLAIM_READ"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Claim Notification",
    "source": null,
    "evidence": null,
    "expectedOperations": 2,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 2,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/claim-notification/v2/request/damage/{consentId}",
        "summary": "Submit damage claim notification",
        "requiredScopes": ["CLAIM_NOTIFICATION_REQUEST_DAMAGE_CREATE"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "post",
        "path": "/open-insurance/claim-notification/v2/request/person/{consentId}",
        "summary": "Submit person claim notification",
        "requiredScopes": ["CLAIM_NOTIFICATION_REQUEST_PERSON_CREATE"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Quote Auto",
    "source": null,
    "evidence": null,
    "expectedOperations": 5,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 5,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/quote-auto/v2/lead/request",
        "summary": "Envia dados de cotação e contratação de AutoLead",
        "requiredScopes": ["quote-auto-lead"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-auto/v2/lead/request/{consentId}",
        "summary": "Atualiza dados de cotação e contratação de AutoLead identificado por consentId",
        "requiredScopes": ["quote-auto-lead"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "post",
        "path": "/open-insurance/quote-auto/v2/request",
        "summary": "Envia dados de cotação e contratação de Auto",
        "requiredScopes": ["quote-auto"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/quote-auto/v2/request/{consentId}/quote-status",
        "summary": "Obtém os dados de cotação e contratação de Auto identificado por consentId",
        "requiredScopes": ["quote-auto"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-auto/v2/request/{consentId}",
        "summary": "Atualiza dados de cotação e contratação de Auto identificado por consentId",
        "requiredScopes": ["quote-auto"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Quote Housing",
    "source": null,
    "evidence": null,
    "expectedOperations": 2,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 2,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/quote-housing/v2/lead/request",
        "summary": "Envia dados de solicitação de cotação de HousingLead",
        "requiredScopes": ["quote-housing-lead"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-housing/v2/lead/request/{consentId}",
        "summary": "Atualiza dados de solicitação de cotação de HousingLead identificado por consentId",
        "requiredScopes": ["quote-housing-lead"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Quote Rural",
    "source": null,
    "evidence": null,
    "expectedOperations": 2,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 2,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/quote-rural/v2/lead/request",
        "summary": "Envia dados de cotação de RuralLead",
        "requiredScopes": ["quote-rural-lead"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-rural/v2/lead/request/{consentId}",
        "summary": "Atualiza dados de cotação de RuralLead identificado por consentId",
        "requiredScopes": ["quote-rural-lead"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Quote Transport",
    "source": null,
    "evidence": null,
    "expectedOperations": 2,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 2,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/quote-transport/v2/lead/request",
        "summary": "Envia dados de cotação de TransportLead",
        "requiredScopes": ["quote-transport-lead"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-transport/v2/lead/request/{consentId}",
        "summary": "Atualiza dados de cotação de TransportLead identificado por consentId",
        "requiredScopes": ["quote-transport-lead"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Quote Person",
    "source": null,
    "evidence": null,
    "expectedOperations": 8,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 8,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/quote-person/v2/lead/request",
        "summary": "Envia dados de cotação e contratação de PersonLead",
        "requiredScopes": ["openid", "quote-person-lead"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-person/v2/lead/request/{consentId}",
        "summary": "Atualiza dados de cotação e contratação de PersonLead identificado por consentId",
        "requiredScopes": ["openid", "quote-person-lead"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "post",
        "path": "/open-insurance/quote-person/v2/life/request",
        "summary": "Envia dados de cotação e contratação de PersonLife",
        "requiredScopes": ["openid", "quote-person-life"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/quote-person/v2/life/request/{consentId}/quote-status",
        "summary": "Obtém os dados de cotação e contratação de PersonLife identificado por consentId",
        "requiredScopes": ["openid", "quote-person-life"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-person/v2/life/request/{consentId}",
        "summary": "Atualiza dados de cotação e contratação de PersonLife identificado por consentId",
        "requiredScopes": ["openid", "quote-person-life"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "post",
        "path": "/open-insurance/quote-person/v2/travel/request",
        "summary": "Envia dados de cotação e contratação de PersonTravel",
        "requiredScopes": ["openid", "quote-person-travel"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/quote-person/v2/travel/request/{consentId}/quote-status",
        "summary": "Obtém os dados de cotação e contratação de PersonTravel identificado por consentId",
        "requiredScopes": ["openid", "quote-person-travel"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-person/v2/travel/request/{consentId}",
        "summary": "Atualiza dados de cotação e contratação de PersonTravel identificado por consentId",
        "requiredScopes": ["openid", "quote-person-travel"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Quote Capitalization Title",
    "source": null,
    "evidence": null,
    "expectedOperations": 6,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 6,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/quote-capitalization-title/v2/lead/request",
        "summary": "Envia dados de cotação e compra de CapitalizationTitleLead",
        "requiredScopes": ["openid", "quote-capitalization-title-lead"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-capitalization-title/v2/lead/request/{consentId}",
        "summary": "Atualiza dados de cotação e compra de CapitalizationTitleLead identificado por consentId",
        "requiredScopes": ["openid", "quote-capitalization-title-lead"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "post",
        "path": "/open-insurance/quote-capitalization-title/v2/request",
        "summary": "Envia dados de cotação e compra de CapitalizationTitle",
        "requiredScopes": ["openid", "quote-capitalization-title"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/quote-capitalization-title/v2/request/{consentId}/quote-status",
        "summary": "Obtém os dados de cotação e compra de CapitalizationTitle identificado por consentId",
        "requiredScopes": ["openid", "quote-capitalization-title"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-capitalization-title/v2/request/{consentId}",
        "summary": "Atualiza dados de cotação e compra de CapitalizationTitle identificado por consentId",
        "requiredScopes": ["openid", "quote-capitalization-title"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "post",
        "path": "/open-insurance/quote-capitalization-title/v2/raffle/request",
        "summary": "Enviar os dados de solicitação de Pagamento de Sorteio de Título de Capitalização",
        "requiredScopes": ["openid", "quote-capitalization-title-raffle"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Contract Life Pension",
    "source": null,
    "evidence": null,
    "expectedOperations": 5,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 5,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/contract-life-pension/v2/lead/request",
        "summary": "Envia dados de solicitação de contratação de LifePensionLead",
        "requiredScopes": ["openid", "contract-life-pension-lead"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/contract-life-pension/v2/lead/request/{consentId}",
        "summary": "Atualiza dados solicitação de de contratação de LifePensionLead identificado por consentId",
        "requiredScopes": ["openid", "contract-life-pension-lead"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "post",
        "path": "/open-insurance/contract-life-pension/v2/request",
        "summary": "Envia dados de solicitação de Contratação e Portabilidade Firme Previdência Sobrevivência",
        "requiredScopes": ["openid", "contract-life-pension"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/contract-life-pension/v2/request/{consentId}/quote-status",
        "summary": "Obtém os dados de Contratação e Portabilidade Firme Previdência Sobrevivência identificado por consentId",
        "requiredScopes": ["openid", "contract-life-pension"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/contract-life-pension/v2/request/{consentId}",
        "summary": "Atualiza dados de Contratação e Portabilidade Firme Previdência Sobrevivência identificado por consentId",
        "requiredScopes": ["openid", "contract-life-pension"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Withdrawal",
    "source": null,
    "evidence": null,
    "expectedOperations": 3,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 3,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/withdrawal/v2/lead/request",
        "summary": "Envia dados de solicitação de Resgate de Previdência Lead",
        "requiredScopes": ["openid", "withdrawal-pension-lead"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "post",
        "path": "/open-insurance/withdrawal/v2/pension/request",
        "summary": "Enviar os dados de solicitação de Resgate de Previdência",
        "requiredScopes": ["openid", "withdrawal-pension"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "post",
        "path": "/open-insurance/withdrawal/v2/capitalization-title/request",
        "summary": "Enviar os dados de solicitação de Resgate de Título de Capitalização",
        "requiredScopes": ["openid", "withdrawal-capitalization-title"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Dynamic Fields",
    "source": null,
    "evidence": null,
    "expectedOperations": 4,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 4,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/dynamic-fields/v2/damage-and-person",
        "summary": "Obtém a lista de Campos dinâmicos de Danos e Pessoas.",
        "requiredScopes": ["dynamic-fields"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/dynamic-fields/v2/capitalization-title",
        "summary": "Obtém a lista de Campos dinâmicos de Títulos de Capitalização.",
        "requiredScopes": ["dynamic-fields"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "post",
        "path": "/open-insurance/dynamic-fields/v2/callback/damage-and-person",
        "summary": "Informa via callback a consulta e a atualização dos campos dinâmicos.",
        "requiredScopes": ["dynamic-fields"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "post",
        "path": "/open-insurance/dynamic-fields/v2/callback/capitalization-title",
        "summary": "Informa via callback a consulta e a atualização dos campos dinâmicos.",
        "requiredScopes": ["dynamic-fields"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Webhook",
    "source": null,
    "evidence": null,
    "expectedOperations": 4,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 4,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/webhook/v2/quote/{versionApi}/request/{consentId}/quote-status",
        "summary": "Notificação de mudança no estado da cotação referente as APIs de Contratação (Danos, Previdência, Pessoas e Capitalização)",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      },
      {
        "method": "post",
        "path": "/open-insurance/webhook/v2/products-services/{authorisationServerId}/{versionApi}/capitalization-title",
        "summary": "Notificações de mudanças de payload referente a API de Produtos de Título de Capitalização.",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      },
      {
        "method": "post",
        "path": "/open-insurance/webhook/v2/dynamic-fields/{authorisationServerId}/{versionApi}/damage-and-person",
        "summary": "Notificações de mudanças no payload da API de Campos Dinâmicos.",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      },
      {
        "method": "post",
        "path": "/open-insurance/webhook/v2/dynamic-fields/{authorisationServerId}/{versionApi}/capitalization-title",
        "summary": "Notificações de mudanças no payload da API de Campos Dinâmicos.",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Data Channels (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 3,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 3,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/channels/v3/branches",
        "summary": "List physical branches",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/channels/v3/electronic-channels",
        "summary": "List electronic channels",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/channels/v3/phone-channels",
        "summary": "List phone channels",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Intermediary",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/channels/v2/intermediary/{countrySubDivision}",
        "summary": "List intermediaries for an UF",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Intermediary (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/channels/v3/intermediary/{countrySubDivision}",
        "summary": "List intermediaries for an UF",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Referenced Network",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/channels/v2/referenced-network/{countrySubDivision}/{serviceType}",
        "summary": "List referenced network partners by service type",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Referenced Network (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/channels/v3/referenced-network/{countrySubDivision}/{serviceType}",
        "summary": "List referenced network partners by service type",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Assistance General Assets",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/assistance-general-assets",
        "summary": "List assistance-general-assets open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Assistance General Assets (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/assistance-general-assets",
        "summary": "List assistance-general-assets open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Auto Extended Warranty",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/auto-extended-warranty",
        "summary": "List auto-extended-warranty open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Auto Extended Warranty (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/auto-extended-warranty",
        "summary": "List auto-extended-warranty open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Auto Insurance",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/auto-insurance/{vehicleOvernightZipCode}/{fipeCode}/{year}",
        "summary": "List auto-insurance products for a vehicle",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Auto Insurance (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/auto-insurance/{vehicleOvernightZipCode}/{fipeCode}/{year}",
        "summary": "List auto-insurance products for a vehicle",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Business",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/business",
        "summary": "List business open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Business (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/business",
        "summary": "List business open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Capitalization Title",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/capitalization-title",
        "summary": "List capitalization-title open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Capitalization Title (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/capitalization-title",
        "summary": "List capitalization-title open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Condominium",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/condominium/{commercializationArea}",
        "summary": "List condominium products by commercialization area",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Condominium (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/condominium/{commercializationArea}",
        "summary": "List condominium products by commercialization area",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Cyber Risk",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/cyber-risk",
        "summary": "List cyber-risk open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Cyber Risk (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/cyber-risk",
        "summary": "List cyber-risk open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Directors & Officers Liability",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/directors-officers-liability",
        "summary": "List directors-officers-liability open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Directors & Officers Liability (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/directors-officers-liability",
        "summary": "List directors-officers-liability open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Domestic Credit",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/domestic-credit",
        "summary": "List domestic-credit open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Domestic Credit (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/domestic-credit",
        "summary": "List domestic-credit open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Engineering",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/engineering",
        "summary": "List engineering open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Engineering (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/engineering",
        "summary": "List engineering open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Environmental Liability",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/environmental-liability",
        "summary": "List environmental-liability open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Environmental Liability (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/environmental-liability",
        "summary": "List environmental-liability open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Equipment Breakdown",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/equipment-breakdown",
        "summary": "List equipment-breakdown open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Equipment Breakdown (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/equipment-breakdown",
        "summary": "List equipment-breakdown open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Errors & Omissions Liability",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/errors-omissions-liability",
        "summary": "List errors-omissions-liability open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Errors & Omissions Liability (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/errors-omissions-liability",
        "summary": "List errors-omissions-liability open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Export Credit",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/export-credit",
        "summary": "List export-credit open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Export Credit (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/export-credit",
        "summary": "List export-credit open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Extended Warranty",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/extended-warranty",
        "summary": "List extended-warranty open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Extended Warranty (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/extended-warranty",
        "summary": "List extended-warranty open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Financial Risk",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/financial-risk",
        "summary": "List financial-risk open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Financial Risk (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/financial-risk",
        "summary": "List financial-risk open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — General Liability",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/general-liability",
        "summary": "List general-liability open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — General Liability (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/general-liability",
        "summary": "List general-liability open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Home Insurance",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/home-insurance/commercializationArea/{commercializationArea}",
        "summary": "List home-insurance products by commercialization area",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Home Insurance (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/home-insurance/commercializationArea/{commercializationArea}",
        "summary": "List home-insurance products by commercialization area",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Housing",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/housing",
        "summary": "List housing open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Housing (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/housing",
        "summary": "List housing open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Life Pension",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/life-pension",
        "summary": "List life-pension open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Life Pension (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/life-pension",
        "summary": "List life-pension open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Lost Profit",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/lost-profit",
        "summary": "List lost-profit open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Lost Profit (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/lost-profit",
        "summary": "List lost-profit open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Pension Plan",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/pension-plan",
        "summary": "List pension-plan open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Pension Plan (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/pension-plan",
        "summary": "List pension-plan open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Person",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/person",
        "summary": "List person open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Person (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/person",
        "summary": "List person open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Private Guarantee",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/private-guarantee",
        "summary": "List private-guarantee open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Private Guarantee (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/private-guarantee",
        "summary": "List private-guarantee open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Public Guarantee",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/public-guarantee",
        "summary": "List public-guarantee open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Public Guarantee (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/public-guarantee",
        "summary": "List public-guarantee open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Rent Guarantee",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/rent-guarantee",
        "summary": "List rent-guarantee open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Rent Guarantee (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/rent-guarantee",
        "summary": "List rent-guarantee open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Rural",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/rural",
        "summary": "List rural open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Rural (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/rural",
        "summary": "List rural open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Stop Loss",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/stop-loss",
        "summary": "List stop-loss open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Stop Loss (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/stop-loss",
        "summary": "List stop-loss open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Transport",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v2/transport",
        "summary": "List transport open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Open Data — Transport (v3)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/products-services/v3/transport",
        "summary": "List transport open data",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Endorsement",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/endorsement/v2/request/{consentId}",
        "summary": "Submit endorsement request for an active consent",
        "requiredScopes": ["endorsement"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Notifications",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/notifications/v1/quote-notification",
        "summary": "Publish quote acceptance/rejection notification",
        "requiredScopes": ["notifications"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Quote Patrimonial",
    "source": null,
    "evidence": null,
    "expectedOperations": 14,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 14,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/quote-patrimonial/v2/lead/request",
        "summary": "Create patrimonial lead",
        "requiredScopes": ["quote-patrimonial-lead"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-patrimonial/v2/lead/request/{consentId}",
        "summary": "Revoke patrimonial lead",
        "requiredScopes": ["quote-patrimonial-lead"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "post",
        "path": "/open-insurance/quote-patrimonial/v2/home/request",
        "summary": "Create patrimonial home quote",
        "requiredScopes": ["quote-patrimonial-home"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/quote-patrimonial/v2/home/request/{consentId}/quote-status",
        "summary": "Read patrimonial home quote status",
        "requiredScopes": ["quote-patrimonial-home"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-patrimonial/v2/home/request/{consentId}",
        "summary": "Cancel patrimonial home quote",
        "requiredScopes": ["quote-patrimonial-home"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "post",
        "path": "/open-insurance/quote-patrimonial/v2/condominium/request",
        "summary": "Create patrimonial condominium quote",
        "requiredScopes": ["quote-patrimonial-condominium"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/quote-patrimonial/v2/condominium/request/{consentId}/quote-status",
        "summary": "Read patrimonial condominium quote status",
        "requiredScopes": ["quote-patrimonial-condominium"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-patrimonial/v2/condominium/request/{consentId}",
        "summary": "Cancel patrimonial condominium quote",
        "requiredScopes": ["quote-patrimonial-condominium"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "post",
        "path": "/open-insurance/quote-patrimonial/v2/business/request",
        "summary": "Create patrimonial business quote",
        "requiredScopes": ["quote-patrimonial-business"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/quote-patrimonial/v2/business/request/{consentId}/quote-status",
        "summary": "Read patrimonial business quote status",
        "requiredScopes": ["quote-patrimonial-business"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-patrimonial/v2/business/request/{consentId}",
        "summary": "Cancel patrimonial business quote",
        "requiredScopes": ["quote-patrimonial-business"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "post",
        "path": "/open-insurance/quote-patrimonial/v2/diverse-risks/request",
        "summary": "Create patrimonial diverse-risks quote",
        "requiredScopes": ["quote-patrimonial-diverse-risks"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/quote-patrimonial/v2/diverse-risks/request/{consentId}/quote-status",
        "summary": "Read patrimonial diverse-risks quote status",
        "requiredScopes": ["quote-patrimonial-diverse-risks"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-patrimonial/v2/diverse-risks/request/{consentId}",
        "summary": "Cancel patrimonial diverse-risks quote",
        "requiredScopes": ["quote-patrimonial-diverse-risks"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Quote Responsibility",
    "source": null,
    "evidence": null,
    "expectedOperations": 2,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 2,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/quote-responsibility/v2/lead/request",
        "summary": "Create quote-responsibility lead",
        "requiredScopes": ["quote-responsibility-lead"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-responsibility/v2/lead/request/{consentId}",
        "summary": "Revoke quote-responsibility lead",
        "requiredScopes": ["quote-responsibility-lead"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Quote Financial Risk",
    "source": null,
    "evidence": null,
    "expectedOperations": 2,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 2,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/quote-financial-risk/v2/lead/request",
        "summary": "Create quote-financial-risk lead",
        "requiredScopes": ["quote-financial-risk-lead"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-financial-risk/v2/lead/request/{consentId}",
        "summary": "Revoke quote-financial-risk lead",
        "requiredScopes": ["quote-financial-risk-lead"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Quote Acceptance And Branches Abroad",
    "source": null,
    "evidence": null,
    "expectedOperations": 2,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 2,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "post",
        "path": "/open-insurance/quote-acceptance-and-branches-abroad/v2/lead/request",
        "summary": "Create acceptance-and-branches-abroad lead",
        "requiredScopes": ["quote-acceptance-and-branches-abroad-lead"],
        "mockOpinStatus": "missing"
      },
      {
        "method": "patch",
        "path": "/open-insurance/quote-acceptance-and-branches-abroad/v2/lead/request/{consentId}",
        "summary": "Revoke acceptance-and-branches-abroad lead",
        "requiredScopes": ["quote-acceptance-and-branches-abroad-lead"],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Comuns (Status & Outages)",
    "source": null,
    "evidence": null,
    "expectedOperations": 2,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 2,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/discovery/v1/status",
        "summary": "List API status",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/discovery/v1/outages",
        "summary": "List scheduled service outages",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Comuns (Status & Outages) (v2)",
    "source": null,
    "evidence": null,
    "expectedOperations": 2,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 2,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/discovery/v2/status",
        "summary": "List API status",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      },
      {
        "method": "get",
        "path": "/open-insurance/discovery/v2/outages",
        "summary": "List scheduled service outages",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Admin (Metrics)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/admin/v1/metrics",
        "summary": "Read API availability metrics",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  },
  {
    "family": "Admin (Metrics) (v2)",
    "source": null,
    "evidence": null,
    "expectedOperations": 1,
    "supportedOperations": 0,
    "variantOperations": 0,
    "missingOperations": 1,
    "coveragePercent": 0,
    "status": "missing",
    "operations": [
      {
        "method": "get",
        "path": "/open-insurance/admin/v2/metrics",
        "summary": "Read API availability metrics",
        "requiredScopes": [],
        "mockOpinStatus": "missing"
      }
    ]
  }
]
